// 转换
import constan from "../constant"

/** vip类型格式化 */
export const vipType = (type: number) => {
  switch (type) {
    case 0:
      return '非会员'
    case 1:
      return 'VIP1'
    case 2:
      return 'VIP2'
    default:
      return '其他'
  }
}

/** 订单状态 */
export const OrderStatusFormat = (type: number) => {
  const os = constan.OrderStatus;
  const res = os.filter(e=>{
    return e.value == type
  })
  if(!res || res.length <= 0){
    return '-'
  }
  return res[0].label
}

/** 订单结算状态 */
export const SettlementFormat = (type: number) => {
  if(type == 1){
    return "已结算"
  }
  return "待结算"
}

/** 订单类型 */
export const OrderTypeFormat = (type: number) => {
  const os = constan.OrderType;
  const res = os.filter(e=>{
    return e.value == type
  })
  if(!res || res.length <= 0){
    return '-'
  }
  return res[0].label
}

/** 账单类型 */
export const BillStatusFormat = (type: number) => {
  const os = constan.BillStatus;
  const res = os.filter(e=>{
    return e.value == type
  })
  if(!res || res.length <= 0){
    return '-'
  }
  return res[0].label
}
/** 是否预期 */
export const OverdueTypeFormat = (type: number) => {
  const os = constan.OverdueType;
  const res = os.filter(e=>{
    return e.value == type
  })
  if(!res || res.length <= 0){
    return '-'
  }
  return res[0].label
}

/** 后台用户，状态 */
export const PlatformStatusFormat = (type: number) => {
  const os = constan.PlatformStatus;
  const res = os.filter(e=>{
    return e.value == type
  })
  if(!res || res.length <= 0){
    return '-'
  }
  return res[0].label
}

/** 支付方式（兼容数字与字符串） */
export const PayChannelFormat = (type: number | string) => {
  const os = constan.PayChannel;
  const res = os.filter(e=>{
    return String(e.value) === String(type)
  })
  if(!res || res.length <= 0){
    return '-'
  }
  return res[0].label
}

/** 优先展示后端计算的 payCompositionLabel（积分/绿豆/混合组合文案），否则回退为渠道码映射 */
export const PayCompositionFormat = (type: number | string, row?: { payCompositionLabel?: string }) => {
  if (row && row.payCompositionLabel) {
    return row.payCompositionLabel
  }
  return PayChannelFormat(type)
}

/** 积分明细状态 */
export const PointsRecordStatusFormat = (type: number) => {
  const os = constan.PointsRecordStatus
  const res = os.filter((e) => e.value === type)
  if (!res || res.length <= 0) {
    return '-'
  }
  return res[0].label
}

/** 签到记录状态 */
export const CheckinRecordStatusFormat = (type: number) => {
  const os = constan.CheckinRecordStatus
  const res = os.filter((e) => e.value === type)
  if (!res || res.length <= 0) {
    return '-'
  }
  return res[0].label
}

/** 支付状态 */
export const PayStatusFormat = (type: number) => {
  const os = constan.PayStatus;
  const res = os.filter(e=>{
    return e.value == type
  })
  if(!res || res.length <= 0){
    return '-'
  }
  return res[0].label
}
/** 退款状态 */
export const RefundStatusFormat = (type: number) => {
  const os = constan.RefundStatus;
  const res = os.filter(e=>{
    return e.value == type
  })
  if(!res || res.length <= 0){
    return '-'
  }
  return res[0].label
}

/** 订单/退款单 refund_type：1=仅退款 2=退货退款（与 cy-api / C 端一致） */
export const RefundOnlyOrReturnFormat = (type: number) => {
  if (type === 1 || type === 0) return '仅退款'
  if (type === 2) return '退货退款'
  return '-'
}
/** 资讯分类 */
export const InformationTypeFormat = (type: number) => {
  const os = constan.InformationType;
  const res = os.filter(e=>{
    return e.value == type
  })
  if(!res || res.length <= 0){
    return '-'
  }
  return res[0].label
}
/** 商品活动类型 */
export const GoodsActivityTypeFormat = (type: number) => {
  const os = constan.GoodsActivityType;
  const res = os.filter(e=>{
    return e.value == type
  })
  if(!res || res.length <= 0){
    return '-'
  }
  return res[0].label
}
/** 商品状态 */
export const GoodsStatusFormat = (type: number) => {
  const os = constan.GoodsStatus;
  const res = os.filter(e=>{
    return e.value == type
  })
  if(!res || res.length <= 0){
    return '-'
  }
  return res[0].label
}
/** 社区活动状态 */
export const ActivityInfoStatusFormat = (type: string) => {
  const os = constan.ActivityInfoStatus;
  const res = os.filter(e=>{
    return e.value == type
  })
  if(!res || res.length <= 0){
    return '-'
  }
  return res[0].label
}
/** 供应商门店类型 */
export const SupplierShopTypeFormat = (type: boolean) => {
  const os = constan.SupplierShopType;
  const res = os.filter(e=>{
    return e.value == type
  })
  if(!res || res.length <= 0){
    return '-'
  }
  return res[0].label
}
/** 供应商状态 */
export const SupplierStatusFormat = (type: number) => {
  const os = constan.SupplierStatus;
  const res = os.filter(e=>{
    return e.value == type
  })
  if(!res || res.length <= 0){
    return '-'
  }
  return res[0].label
}
/** 导航栏状态 */
export const NacigationStatusFormat = (type: number) => {
  const os = constan.PlatformStatus;
  const res = os.filter(e=>{
    return e.value == type
  })
  if(!res || res.length <= 0){
    return '-'
  }
  return res[0].label
}
export const NavigationExpansionTypeFormat = (type: string) => {
  const os = constan.NavigationExpansionType;
  const res = os.filter(e=>{
    return e.value == type
  })
  if(!res || res.length <= 0){
    return '-'
  }
  return res[0].label
}

/** 药柜状态 */
export const MedicineCabinetStatusFormat = (type: number) => {
  const os = constan.MedicineCabinetStatus;
  const res = os.filter(e=>{
    return e.value == type
  })
  if(!res || res.length <= 0){
    return '-'
  }
  return res[0].label
}

/** 店铺状态 */
export const PlatformCloseFormat = (type: boolean) => {
  const os = constan.PlatformClose;
  const res = os.filter(e=>{
    return e.value == type
  })
  if(!res || res.length <= 0){
    return '-'
  }
  return res[0].label
}


/** 店铺状态 */
export const ShopStatusFormat = (type: number) => {
  const os = constan.ShopStatus;
  const res = os.filter(e=>{
    return e.value == type
  })
  if(!res || res.length <= 0){
    return '-'
  }
  return res[0].label
}
/** 店铺审核状态 */
export const ShopAuditStatusFormat = (type: number) => {
  const os = constan.ShopAuditStatus;
  const res = os.filter(e=>{
    return e.value == type
  })
  if(!res || res.length <= 0){
    return '-'
  }
  return res[0].label
}
/** 店铺流水-资金类型 */
export const ShopWealthRecordTypeFormat = (type: number) => {
  const os = constan.ShopWealthRecordType;
  const res = os.filter(e=>{
    return e.value == type
  })
  if(!res || res.length <= 0){
    return '-'
  }
  return res[0].label
}
/** 店铺流水-变更途径 */
export const ShopWealthWayTypeFormat = (type: number) => {
  const os = constan.ShopWealthWayType;
  const res = os.filter(e=>{
    return e.value == type
  })
  if(!res || res.length <= 0){
    return '-'
  }
  return res[0].label
}
/** 店铺审核状态 */
export const ApplicationStatusFormat = (t: string) => {
  let type = t
  if(!type){
    type = "WAIT"
  }
  const os = constan.ApplicationStatus;
  const res = os.filter(e=>{
    return e.value == type
  })
  if(!res || res.length <= 0){
    return '-'
  }
  return res[0].label
}
/** 易宝入网处理状态 */
export const RegistMerchantStatusFormat = (type: string) => {
  const os = constan.RegistMerchantStatus;
  const res = os.filter(e=>{
    return e.value == type
  })
  if(!res || res.length <= 0){
    return '-'
  }
  return res[0].label
}
/** 用户角色 */
export const UserRoleFormat = (type: number) => {
  const os = constan.UserRole;
  const res = os.filter(e=>{
    return e.value == type
  })
  if(!res || res.length <= 0){
    return '-'
  }
  return res[0].label
}
/** 用户类型 */
export const UserTypeFormat = (type: number) => {
  const os = constan.UserType;
  const res = os.filter(e=>{
    return e.value == type
  })
  if(!res || res.length <= 0){
    return '-'
  }
  return res[0].label
}
/** 战队类型 */
export const TeamTypeFormat = (type: number) => {
  const os = constan.TeamType;
  const res = os.filter(e=>{
    return e.value == type
  })
  if(!res || res.length <= 0){
    return '-'
  }
  return res[0].label
}
/** 投资人数据上传 */
export const InvestorIncomeFileStatusFormat = (type: number) => {
  const os = constan.InvestorIncomeFileStatus;
  const res = os.filter(e=>{
    return e.value == type
  })
  if(!res || res.length <= 0){
    return '-'
  }
  return res[0].label
}

export const StatusFormat = (type: number) => {
  const os = constan.Status;
  const res = os.filter(e=>{
    return e.value == type
  })
  if(!res || res.length <= 0){
    return '-'
  }
  return res[0].label
}

export const UseTypeFormat = (type: number) => {
  const os = constan.UseType;
  const res = os.filter(e=>{
    return e.value == type
  })
  if(!res || res.length <= 0){
    return '-'
  }
  return res[0].label
}

export const UserVoucherStatusFormat = (type: number) => {
  const os = constan.UserVoucherStatus;
  const res = os.filter(e=>{
    return e.value == type
  })
  if(!res || res.length <= 0){
    return '-'
  }
  return res[0].label
}
// 提现状态 格式化
export const WithdrawStatusFormat = (type: number) => {
  const os = constan.WithdrawStatus;
  const res = os.filter(e=>{
    return e.value == type
  })
  if(!res || res.length <= 0){
    return '-'
  }
  return res[0].label
}

// 银行卡卡类型 格式化
export const BankTypeFormat = (type: number) => {
  const os = constan.BankType;
  const res = os.filter(e=>{
    return e.value == type
  })
  if(!res || res.length <= 0){
    return '-'
  }
  return res[0].label
}

// 银行卡类别 格式化
export const BankAccountTypeFormat = (type: number) => {
  const os = constan.BankAccountType;
  const res = os.filter(e=>{
    return e.value == type
  })
  if(!res || res.length <= 0){
    return '-'
  }
  return res[0].label
}
// 银行卡用途 格式化
export const SourceTypeFormat = (type: number) => {
  const os = constan.SourceType;
  const res = os.filter(e=>{
    return e.value == type
  })
  if(!res || res.length <= 0){
    return '-'
  }
  return res[0].label
}
// 配送方式 格式化
export const DeliveryTypeFormat = (type: number) => {
  const os = constan.DeliveryType;
  const res = os.filter(e=>{
    return e.value == type
  })
  if(!res || res.length <= 0){
    return '-'
  }
  return res[0].label
}
// 配送方式 格式化
export const PlatformWealthRecordTypeFormat = (type: number | string) => {
  if (type === null || type === undefined || type === '') {
    return '-'
  }
  const n = Number(type)
  const os = constan.PlatformWealthRecordType
  const hit = os.find((e) => e.value === n || String(e.value) === String(type))
  return hit ? hit.label : '-'
}

export const PlatformWealthRecordRemarkFormat = (remark: string) => {
  if (remark == null || String(remark).trim() === '') {
    return '-'
  }
  return String(remark)
}
//
export const HuifuAcctTypeFormat = (type: string) => {
  const os = constan.HuifuAcctType;
  const res = os.filter(e=>{
    return e.value == type
  })
  if(!res || res.length <= 0){
    return '-'
  }
  return res[0].label
}
export const HuifuAcctStatFormat = (type: string) => {
  const os = constan.HuifuAcctStat;
  const res = os.filter(e=>{
    return e.value == type
  })
  if(!res || res.length <= 0){
    return '-'
  }
  return res[0].label
}

/** 价格格式化 */
export const PriceFormat = (price: number) => {
  if(!price){
    return "0"
  }
  price = price / 100
  return price.toFixed ? price.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') : '0'
}

export const PriceFormat2 = (price: number) => {
  if(!price){
    return "0"
  }
  return price.toFixed ? price.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') : '0'
}

// 银行卡 加码
export const BandCardFormat = (card: string) => {
  if(card){
    return maskCardNumber(card)
  }
  return "-"
}

// 手机号打码 加码
export const PhoneFormat = (phone: string) => {
  if(phone){
    return maskCardNumber(phone,{
      visibleFirst: 3,
      visibleLast: 4,
      maskChar: '*'
    })
  }
  return "-"
}

export function maskCardNumber(cardNumber: string, options: any = {}) {
  const {
    visibleFirst = 4,
    visibleLast = 4,
    maskChar = '*'
  } = options

  if (!cardNumber || cardNumber.length < visibleFirst + visibleLast) {
    return cardNumber
  }

  const maskedLength = cardNumber.length - visibleFirst - visibleLast
  const mask = maskChar.repeat(maskedLength)
  return `${cardNumber.substring(0, visibleFirst)}${mask}${cardNumber.substring(cardNumber.length - visibleLast)}`
}



/** 后台用户角色 */
export const PlatformRoleFormat = (type: number) => {
  const os = constan.PlatformRole;
  const res = os.filter(e=>{
    return e.value == type
  })
  if(!res || res.length <= 0){
    return '-'
  }
  return res[0].label
}

/** 会员状态 */
export const MemberStatusFormat = (type: number) => {
  const os = constan.MemberStatus;
  const res = os.filter(e=>{
    return e.value == type
  })
  if(!res || res.length <= 0){
    return '-'
  }
  return res[0].label
}

/** 会员降级配置 */
export const MemberIsDemotionFormat = (type: number) => {
  const os = constan.MemberIsDmotion;
  const res = os.filter(e=>{
    return e.value == type
  })
  if(!res || res.length <= 0){
    return '-'
  }
  return res[0].label
}

/** 会员降级配置 */
export const DistributionActivityTypeFormat = (type: number) => {
  const os = constan.DistributionActivityType;
  const res = os.filter(e=>{
    return e.value == type
  })
  if(!res || res.length <= 0){
    return '-'
  }
  return res[0].label
}

/** 会员降级配置 */
export const DistributionActivityNumberTypeFormat = (type: number) => {
  const os = constan.DistributionActivityNumberType;
  const res = os.filter(e=>{
    return e.value == type
  })
  if(!res || res.length <= 0){
    return '-'
  }
  return res[0].label
}

/** 财富类型 */
export const WealthTypeFormat = (type: number) => {
  const os = constan.WealthType;
  const res = os.filter(e=>{
    return e.value == type
  })
  if(!res || res.length <= 0){
    return '-'
  }
  return res[0].label
}

/** 财富途径（与后端 UserWealthWayType 字典一致；未知编码回显数字） */
export const WealthWayTypeFormat = (type: number) => {
  const os = constan.WealthWayType;
  const res = os.filter(e=>{
    return e.value == type
  })
  if(!res || res.length <= 0){
    return type == null || type === undefined ? '-' : String(type)
  }
  return res[0].label
}

/** 入帐状态 */
export const WealthStatusFormat = (type: number) => {
  const os = constan.WealthStatus;
  const res = os.filter(e=>{
    return e.value == type
  })
  if(!res || res.length <= 0){
    return '-'
  }
  return res[0].label
}

/** 会员状态 */
export const MemberAddressConfigLevelFormat = (type: number) => {
  const os = constan.MemberAddressConfigLevel;
  const res = os.filter(e=>{
    return e.value == type
  })
  if(!res || res.length <= 0){
    return '-'
  }
  return res[0].label
}
export const PayChannelMerchantFormat = (type: string) => {
  const os = constan.PayChannelMerchant;
  const res = os.filter(e=>{
    return e.value == type
  })
  if(!res || res.length <= 0){
    return '-'
  }
  return res[0].label
}

export const OrderAllocateErrorTypeFormat = (type: number) => {
  const os = constan.OrderAllocateErrorType;
  const res = os.filter(e=>{
    return e.value == type
  })
  if(!res || res.length <= 0){
    return '-'
  }
  return res[0].label
}
export const OrderAllocateErrorStatusFormat = (type: number) => {
  const os = constan.OrderAllocateErrorStatus;
  const res = os.filter(e=>{
    return e.value == type
  })
  if(!res || res.length <= 0){
    return '-'
  }
  return res[0].label
}